import * as THREE from "three";
import { DragControls } from "three/examples/jsm/controls/DragControls";
import { SceneManagerEvent, WallConfig } from "../scene-manager";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { MathUtils, Vector3 } from "three";
import "svelte/internal";
export function launchStage(renderTarget, manager, langCode) {
    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0x9acd32);
    const width = renderTarget.offsetWidth;
    const height = renderTarget.offsetHeight;
    const camera = new THREE.PerspectiveCamera(60, width / height, 0.1, 100);
    camera.position.set(-2, 2, 5);
    const gltfLoader = new GLTFLoader();
    const cubeTextureLoader = new THREE.CubeTextureLoader();
    const moveMouse = new THREE.Vector2;
    const clickMouse = new THREE.Vector2;
    var startMousePosition = new THREE.Vector2;
    var objectToMove;
    var spawnLocation = new THREE.Vector3(1.5, 0, 2.5);
    var matColors = [];
    var highlightColor = new THREE.Color(0.881, 0.320, 0.188);
    var selectedObjects = [];
    var backlightOffColor = new THREE.Color(0.6, 0.6, 0.6);
    var backlightOnColor = new THREE.Color(1.2, 1.2, 1.2);
    var currentSelection = null;
    var boothWidth = 0;
    var boothDeepth = 0;
    const objectSize = new THREE.Vector3();
    var shadowTarget = false;
    var bannerTrasses;
    var bannerFront;
    var bannerBack;
    var bannerLeft;
    var bannerRight;
    var roundBanner;
    const FloorTexture = new THREE.TextureLoader().load("img/velour_speed.jpg");
    //====================================================================== Renderer
    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 0.7;
    renderTarget.appendChild(renderer.domElement);
    //====================================================================== DragControls
    var dragables = [];
    var draging = false;
    var dragControls = new DragControls(dragables, camera, renderer.domElement);
    dragControls.addEventListener('dragstart', function () { controls.enabled = false; });
    dragControls.addEventListener('drag', onDragEvent);
    dragControls.addEventListener('dragend', function () { controls.enabled = true; });
    window.addEventListener('click', selectItem);
    window.addEventListener('mousedown', updateMousePos);
    window.addEventListener('mouseup', mouseReleased);
    window.addEventListener("mousemove", event => {
        var rect = renderer.domElement.getBoundingClientRect();
        moveMouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        moveMouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
    });
    //====================================================================== Raycaster
    const raycaster = new THREE.Raycaster();
    function intersect(pos) {
        raycaster.setFromCamera(pos, camera);
        return raycaster.intersectObjects(scene.children, true);
    }
    //====================================================================== Interaction
    function mouseReleased() {
        runTimer = false;
        shadowTarget = false;
        currentSelection = null;
        draging = false;
    }
    function updateMousePos(e) {
        runTimer = true;
        var rect = renderer.domElement.getBoundingClientRect();
        startMousePosition.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
        startMousePosition.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
        raycaster.setFromCamera(moveMouse, camera);
        var intersects = raycaster.intersectObjects(scene.children, true);
        if (intersects[0].object.name == "ShadowPlane") {
            shadowTarget = true;
        }
        if (intersects[0].object.userData.isRemovable) {
            currentSelection = intersects[0].object;
        }
    }
    document.getElementById("deleteButton").addEventListener("click", function () {
        if (objectToMove != null) {
            manager.selectedItems.forEach((item) => {
                var objToRemove = scene.getObjectByName(item.id);
                for (var i = 0; i < dragables.length; i++) {
                    if (dragables[i].name == item.id) {
                        dragables.splice(i, 1);
                    }
                }
                scene.remove(objToRemove);
                manager.removeItem(item.id);
            });
        }
    });
    document.addEventListener("keydown", onDocumentKeyDown, false);
    function onDocumentKeyDown(event) {
        var keyCode = event.which;
        if (keyCode == 46) {
            if (objectToMove != null && objectToMove.userData.isRemovable == true) {
                var objToRemove = scene.getObjectByName(manager.selectedItems[0].id);
                for (var i = 0; i < dragables.length; i++) {
                    if (dragables[i].name == manager.selectedItems[0].id) {
                        dragables.splice(i, 1);
                    }
                }
                scene.remove(objToRemove);
                manager.removeItem(manager.selectedItems[0].id);
            }
        }
    }
    ;
    document.getElementById("rotateLeftButton").addEventListener("click", function (e) {
        e.stopPropagation();
        scene.traverse((child) => {
            //TODO support rotating multiple items
            if (child.name === manager.selectedItems[0].id && !manager.selectedItems[0].locked) {
                let { rY = 0 } = manager.selectedItems[0];
                if (child.userData.isPannel == true) {
                    rY -= Math.PI * 0.5;
                }
                else {
                    rY -= Math.PI * 0.25;
                }
                rY = rY > Math.PI ? rY - 2 * Math.PI : rY < -Math.PI ? rY + 2 * Math.PI : rY;
                child.setRotationFromAxisAngle(new Vector3(0, 1, 0), rY);
                manager.putItem(Object.assign(Object.assign({}, manager.selectedItems[0]), { rY }));
            }
        });
    });
    document.getElementById("rotateRightButton").addEventListener("click", function (e) {
        e.stopPropagation();
        scene.traverse((child) => {
            //TODO support rotating multiple items
            if (child.name === manager.selectedItems[0].id && !manager.selectedItems[0].locked) {
                let { rY = 0 } = manager.selectedItems[0];
                if (child.userData.isPannel == true) {
                    rY += Math.PI * 0.5;
                }
                else {
                    rY += Math.PI * 0.25;
                }
                rY = rY > Math.PI ? rY - 2 * Math.PI : rY < -Math.PI ? rY + 2 * Math.PI : rY;
                child.setRotationFromAxisAngle(new Vector3(0, 1, 0), rY);
                manager.putItem(Object.assign(Object.assign({}, manager.selectedItems[0]), { rY }));
            }
        });
    });
    function selectItem(e) {
        var rect = renderer.domElement.getBoundingClientRect();
        clickMouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
        clickMouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
        const intersects = intersect(clickMouse);
        var isBack;
        if (intersects[1] != undefined && intersects[1].object.name == "BackPlane") {
            isBack = true;
        }
        else {
            isBack = false;
        }
        if (startMousePosition.distanceTo(moveMouse) > 0.03) {
            return;
        }
        if (objectToMove == null) {
            if (intersects.length > 0 && !draging) {
                if (intersects[0].object.userData.isSelectable) {
                    objectToMove = intersects[0].object;
                    selectedObjects.push(objectToMove);
                    manager.selectItem(intersects[0].object.name, e.shiftKey, { back: isBack });
                    saveMaterials();
                }
            }
        }
        else {
            if (!intersects[0].object.userData.isSelectable) {
                restoreMaterials();
                manager.selectItem(null);
                objectToMove = null;
            }
            else {
                if (objectToMove.name != intersects[0].object.name) {
                    if (!e.shiftKey) {
                        restoreMaterials();
                    }
                    objectToMove = intersects[0].object;
                    selectedObjects.push(objectToMove);
                    manager.selectItem(intersects[0].object.name, e.shiftKey, { back: isBack });
                    saveMaterials();
                    // if (!manager.selectedItems[manager.selectedItems.length-1].name.startsWith("Außenwand") && manager.selectedItems.length > 1) {
                    //     restoreMaterials()
                    //     manager.selectItem(null)
                    //     objectToMove = null
                    // } 
                }
            }
        }
        draging = false;
    }
    //this need threeJS version 0.119 in order to work!!!
    var plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
    var intersects = new THREE.Vector3();
    function onDragEvent(e) {
        const item = manager.getItem(e.object.name);
        if (item === null || item === void 0 ? void 0 : item.locked) {
            e.object.position.set(item.x, item.y, item.z);
            draging = true;
            return;
        }
        new THREE.Box3().setFromObject(e.object).getSize(objectSize);
        raycaster.setFromCamera(moveMouse, camera);
        raycaster.ray.intersectPlane(plane, intersects);
        if (e.object.userData.isPannel == true) {
            //e.object.position.set( Math.round(intersects.x*2)/2, Math.round(intersects.y), Math.round(intersects.z*2)/2);
            e.object.position.set(MathUtils.clamp(Math.round(intersects.x * 2) / 2, -(boothWidth / 2), (boothWidth / 2)), intersects.y, MathUtils.clamp(Math.round(intersects.z * 2) / 2, -(boothDeepth / 2), +(boothDeepth / 2)));
        }
        else {
            e.object.position.set(MathUtils.clamp(intersects.x, -(boothWidth / 2) + objectSize.x / 2, (boothWidth / 2) - objectSize.x / 2), intersects.y, MathUtils.clamp(intersects.z, -(boothDeepth / 2) + objectSize.z / 2, (boothDeepth) - objectSize.z / 2));
        }
        if (item) {
            manager.putItem(Object.assign(Object.assign({}, item), { x: e.object.position.x, y: e.object.position.y, z: e.object.position.z }));
        }
        draging = true;
    }
    var poi = new THREE.Vector3();
    var n = new THREE.Vector3();
    var la = new THREE.Vector3();
    let i0 = null;
    function dragOnSurface(_objectToMove) {
        const item = manager.getItem(_objectToMove.name);
        if (item === null || item === void 0 ? void 0 : item.locked) {
            _objectToMove.position.set(item.x, item.y, item.z);
            return;
        }
        raycaster.setFromCamera(moveMouse, camera);
        var intersects = raycaster.intersectObjects(scene.children, true); //whats wrong with this???? The function is updating but my rayPoint is not.
        //var intersects = intersect(moveMouse);  
        if (intersects.length > 0) {
            for (var i = 0; i < intersect.length; i++) {
                if (intersects[i].object.userData.isPannel) {
                    i0 = intersects[i];
                }
                else {
                    i0 = null;
                }
            }
            if (i0 != null) {
                let obj = i0.object;
                const p = i0.point;
                poi.copy(i0.point);
                n.copy(i0.face.normal);
                n.transformDirection(obj.matrixWorld);
                la.copy(poi).add(n);
                _objectToMove.position.copy(poi);
                _objectToMove.lookAt(la);
                if (item) {
                    let rY = _objectToMove.rotation.y;
                    if (parseFloat(rY.toFixed(5)) === 0 && Math.abs(parseFloat(_objectToMove.quaternion.y.toFixed(5))) === 1) {
                        rY = Math.PI;
                    }
                    manager.putItem(Object.assign(Object.assign({}, item), { x: _objectToMove.position.x, y: _objectToMove.position.y, z: _objectToMove.position.z, rY }));
                }
            }
        }
    }
    function dragOnEdge(_objectToMove) {
        const item = manager.getItem(_objectToMove.name);
        if (item === null || item === void 0 ? void 0 : item.locked) {
            _objectToMove.position.set(item.x, item.y, item.z);
            return;
        }
        raycaster.setFromCamera(moveMouse, camera);
        var intersects = intersect(moveMouse);
        if (intersects.length > 0) {
            for (var i = 0; i < intersect.length; i++) {
                if (intersects[0].object.userData.isPannel) {
                    i0 = intersects[i];
                }
                else {
                    i0 = null;
                }
            }
            if (i0 != null) {
                let obj = i0.object;
                const p = i0.point;
                poi.copy(i0.point);
                n.copy(i0.face.normal);
                n.transformDirection(obj.matrixWorld);
                la.copy(poi).add(n);
                _objectToMove.position.set(poi.x, poi.y, poi.z);
                _objectToMove.lookAt(la);
                _objectToMove.position.y = i0.object.userData.height;
                if (item) {
                    let rY = _objectToMove.rotation.y;
                    if (parseFloat(rY.toFixed(5)) === 0 && Math.abs(parseFloat(_objectToMove.quaternion.y.toFixed(5))) === 1) {
                        rY = Math.PI;
                    }
                    manager.putItem(Object.assign(Object.assign({}, item), { x: _objectToMove.position.x, y: _objectToMove.position.y, z: _objectToMove.position.z, rY }));
                }
            }
        }
    }
    //====================================================================== Environment
    function generateTrasses() {
        bannerTrasses = new THREE.Group();
        bannerTrasses.name = "bannerTrassess";
        bannerFront = new THREE.Object3D();
        bannerTrasses.add(bannerFront);
        bannerBack = new THREE.Object3D();
        bannerTrasses.add(bannerBack);
        bannerLeft = new THREE.Object3D();
        bannerTrasses.add(bannerLeft);
        bannerRight = new THREE.Object3D();
        bannerTrasses.add(bannerRight);
        //load trasse connectors
        gltfLoader.load("glb/TraverseVerbinder.glb", (gltf) => {
            var verbinderFL = gltf.scene.children[0].clone();
            verbinderFL.position.set(-manager.width / 2, 0, manager.depth / 2);
            var verbinderFR = gltf.scene.children[0].clone();
            verbinderFR.position.set(manager.width / 2, 0, manager.depth / 2);
            var verbinderBL = gltf.scene.children[0].clone();
            verbinderBL.position.set(-manager.width / 2, 0, -manager.depth / 2);
            var verbinderBR = gltf.scene.children[0].clone();
            verbinderBR.position.set(manager.width / 2, 0, -manager.depth / 2);
            bannerTrasses.add(verbinderFL);
            bannerTrasses.add(verbinderFR);
            bannerTrasses.add(verbinderBL);
            bannerTrasses.add(verbinderBR);
        });
        //load trasse trasse beams
        gltfLoader.load("glb/Traverse_1m.glb", (gltf) => {
            for (var i = 0; i < manager.width; i++) {
                var trasse = gltf.scene.clone();
                trasse.position.set((-manager.width / 2) + i, 0, manager.depth / 2);
                bannerTrasses.add(trasse);
            }
            for (var i = 0; i < manager.width; i++) {
                var trasse = gltf.scene.clone();
                trasse.position.set((-manager.width / 2) + i, 0, -manager.depth / 2);
                bannerTrasses.add(trasse);
            }
            for (var i = 0; i < manager.depth; i++) {
                var trasse = gltf.scene.clone();
                trasse.rotateY(Math.PI * -0.5);
                trasse.position.set((-manager.width / 2), 0, (manager.depth / 2 - 1) - i);
                bannerTrasses.add(trasse);
            }
            for (var i = 0; i < manager.depth; i++) {
                var trasse = gltf.scene.clone();
                trasse.rotateY(Math.PI * -0.5);
                trasse.position.set((manager.width / 2), 0, -manager.depth / 2 + i);
                bannerTrasses.add(trasse);
            }
        });
        //load flat banners
        gltfLoader.load("glb/Banner_flat.glb", (gltf) => {
            var bF = gltf.scene.children[0].clone();
            bannerFront.position.set(0, -0.2, manager.depth / 2);
            bannerFront.add(bF);
            var bB = gltf.scene.clone();
            bannerBack.position.set(0, -0.2, -manager.depth / 2);
            bannerBack.add(bB);
            var bL = gltf.scene.clone();
            bannerLeft.position.set(-manager.width / 2, -0.2, 0);
            bannerLeft.rotateY(Math.PI * -0.5);
            bannerLeft.add(bL);
            var bR = gltf.scene.clone();
            bannerRight.position.set(manager.width / 2, -0.2, 0);
            bannerRight.rotateY(Math.PI * -0.5);
            bannerRight.add(bR);
            updateBanner(manager.banner, ["left", "right", "front", "back"]);
        });
        bannerFront.visible = false;
        bannerBack.visible = false;
        bannerLeft.visible = false;
        bannerRight.visible = false;
        scene.add(bannerTrasses);
        bannerTrasses.position.set(0, 6.5, 0);
    }
    function clearTrasses() {
        scene.remove(bannerTrasses);
    }
    function setBannerHeight(height) {
        bannerTrasses.position.set(0, height, 0);
    }
    manager.addListener(SceneManagerEvent.Truss, ({ trussHeight }) => {
        setBannerHeight(trussHeight / 100);
    });
    function setBannerSize(position, width, height) {
        switch (position) {
            case "front":
                bannerFront.scale.set(width, height, 0.5);
                break;
            case "back":
                bannerBack.scale.set(width, height, 0.5);
                break;
            case "left":
                bannerLeft.scale.set(width, height, 0.5);
                break;
            case "right":
                bannerRight.scale.set(width, height, 0.5);
                break;
            case "center":
                return setRoundBanner(width * 100, height * 2);
            default:
                console.log("Wrong position: " + position);
        }
    }
    function setBannerVisibility(position, _state) {
        switch (position) {
            case "front":
                bannerFront.visible = _state;
                break;
            case "back":
                bannerBack.visible = _state;
                break;
            case "left":
                bannerLeft.visible = _state;
                break;
            case "right":
                bannerRight.visible = _state;
                break;
            case "center":
                if (roundBanner)
                    roundBanner.visible = _state;
                break;
            default:
                console.log("Wrong position: " + position);
        }
    }
    function setBannerOffset(position, _offset) {
        switch (position) {
            case "front":
                bannerFront.position.set(_offset, bannerFront.position.y, bannerFront.position.z);
                break;
            case "back":
                bannerBack.position.set(_offset, bannerBack.position.y, bannerBack.position.z);
                break;
            case "left":
                bannerLeft.position.set(bannerLeft.position.x, bannerLeft.position.y, _offset);
                break;
            case "right":
                bannerRight.position.set(bannerRight.position.x, bannerRight.position.y, _offset);
                break;
            case "center":
                roundBanner === null || roundBanner === void 0 ? void 0 : roundBanner.position.set(_offset, roundBanner === null || roundBanner === void 0 ? void 0 : roundBanner.position.y, roundBanner === null || roundBanner === void 0 ? void 0 : roundBanner.position.z);
                break;
            default:
                console.log("Wrong position: " + position);
        }
    }
    const roundBannerCache = new Map();
    function setRoundBanner(size, height) {
        if ((roundBanner === null || roundBanner === void 0 ? void 0 : roundBanner.name) === size.toString()) {
            roundBanner.scale.set(1, height, 1);
            return Promise.resolve(true);
        }
        let promise;
        if (roundBannerCache.has(size)) {
            promise = roundBannerCache.get(size);
        }
        else {
            promise = new Promise((resolve) => {
                gltfLoader.load("glb/Banner_round_" + size.toString() + ".glb", (gltf) => {
                    resolve(gltf);
                });
            });
            roundBannerCache.set(size, promise);
        }
        promise.then((gltf) => {
            if (roundBanner != null) {
                var _delObj = [];
                roundBanner.traverse((child) => {
                    _delObj.push(child);
                });
                for (var i = 0; i < _delObj.length; i++) {
                    roundBanner.remove(_delObj[i]);
                }
            }
            roundBanner = gltf.scene.children[0].clone();
            roundBanner.name = "roundBanner";
            roundBanner.position.set(0, -0.2, 0);
            roundBanner.scale.set(1, height, 1);
            roundBanner.name = size.toString();
            bannerTrasses.add(roundBanner);
        });
        return promise;
    }
    manager.addListener(SceneManagerEvent.Banner, ({ banner }) => {
        updateBanner(banner);
    });
    function updateBanner(banner, sides = ["front", "back", "left", "right", "center"]) {
        if (!banner) {
            return;
        }
        const bannerMesh = {
            front: bannerFront,
            back: bannerBack,
            left: bannerLeft,
            right: bannerRight,
            center: roundBanner,
        };
        sides.forEach(async (k) => {
            var _a, _b, _c;
            if ((_a = banner[k]) === null || _a === void 0 ? void 0 : _a.show) {
                const b = banner[k];
                await setBannerSize(k, b.width / 100, b.height / 100);
                if (k === "center") {
                    bannerMesh[k] = roundBanner;
                }
                setBannerVisibility(k, b.show);
                setBannerOffset(k, b.offset / 100);
                if (b.texture) {
                    if (b.texture != bannerMesh[k].userData.texture)
                        _applyTexture(b.texture, bannerMesh[k], 0, 1);
                    _applyTextureOffset(bannerMesh[k], ((_b = b.textureOffset) !== null && _b !== void 0 ? _b : 0) / 100);
                }
                else
                    removePanelTexture(bannerMesh[k]);
                if (b.texture2) {
                    if (b.texture2 != bannerMesh[k].userData.texture2)
                        _applyTexture(b.texture2, bannerMesh[k], 0, 1, false);
                    _applyTextureOffset(bannerMesh[k], ((_c = b.texture2Offset) !== null && _c !== void 0 ? _c : 0) / 100, false);
                }
                else
                    removePanelTexture(bannerMesh[k], false);
            }
            else {
                setBannerVisibility(k, false);
            }
        });
    }
    var ambientLight = new THREE.AmbientLight(0xffffff, 1.0);
    scene.add(ambientLight);
    var pointLight = new THREE.PointLight(0xffffff, 0.3);
    pointLight.position.set(0, 4, 0);
    scene.add(pointLight);
    const environmentMap = cubeTextureLoader.load([
        "glb/px3.jpg",
        "glb/nx3.jpg",
        "glb/py3.jpg",
        "glb/ny3.jpg",
        "glb/pz3.jpg",
        "glb/nz3.jpg",
    ]);
    environmentMap.encoding = THREE.sRGBEncoding;
    scene.environment = environmentMap;
    environmentMap.minFilter = THREE.NearestFilter; //resolution fix, if the performance is too slow, remove this!
    //gltfLoader.load("glb/environment.glb", (gltf) => {
    gltfLoader.load("glb/NeueHalle_sphere.glb", (gltf) => {
        gltf.scene.position.set(0, -0.02, 0);
        gltf.scene.scale.set(5, 5, 5);
        scene.add(gltf.scene);
        updateMaterials();
    });
    //generate Floor
    const geometry = new THREE.BoxGeometry(1, 0.2, 1);
    const material = new THREE.MeshStandardMaterial({ map: FloorTexture, color: 0x202020 });
    const floor = new THREE.Mesh(geometry, material);
    floor.position.set(0, -0.02, 0);
    floor.userData.isRemovable = false;
    floor.userData.isFloor = true;
    scene.add(floor);
    const walls = new Set();
    function buildWalls(w, d, h, config) {
        /*
             _ _w_ _
            |       |
            |       | d
            |       |
        */
        let i = 1;
        //left wall
        if ([WallConfig.Left, WallConfig.U].includes(config)) {
            for (var l = d; l > 0; l--) {
                manager.putItem({
                    type: "Pannel_100x250",
                    name: langCode === "en" ? `Outer wall #${i}` : `Außenwand #${i}`,
                    variant: h.toString(),
                    x: -w / 2,
                    z: (l - d / 2),
                    rY: Math.PI * 0.5,
                    w: i,
                    height: h,
                });
                i++;
            }
        }
        //back wall
        if (config != WallConfig.None) {
            for (var b = 0; b < w; b++) {
                manager.putItem({
                    type: "Pannel_100x250",
                    name: langCode === "en" ? `Outer wall #${i}` : `Außenwand #${i}`,
                    variant: h.toString(),
                    x: b - w / 2,
                    z: -d / 2,
                    w: i,
                    height: h,
                });
                i++;
            }
        }
        //right wall
        if ([WallConfig.Right, WallConfig.U].includes(config)) {
            for (var r = 0; r < d; r++) {
                manager.putItem({
                    type: "Pannel_100x250",
                    name: langCode === "en" ? `Outer wall #${i}` : `Außenwand #${i}`,
                    variant: h.toString(),
                    x: w - w / 2,
                    z: r - d / 2,
                    rY: Math.PI * -0.5,
                    w: i,
                    height: h,
                });
                i++;
            }
        }
    }
    function clearWalls() {
        walls.forEach(w => {
            scene.remove(w);
            for (var i = 0; i < dragables.length; i++) {
                if (dragables[i].name == w.name) {
                    dragables.splice(i, 1);
                }
            }
        });
        walls.clear();
    }
    var bg = "#eeeeee";
    scene.background = new THREE.Color(bg);
    renderTarget.style.backgroundColor = bg;
    //====================================================================== Size Floor
    function setFloorSize(width, depth) {
        spawnLocation = new Vector3(0, 0, depth / 2 + 0.5);
        boothWidth = width;
        boothDeepth = depth;
        scene.traverse((child) => {
            if (child.userData.isFloor && child.isObject3D) {
                child.scale.set(width, 0.15, depth);
                setFloorType("velour_speed");
            }
        });
    }
    setFloorSize(manager.width, manager.depth);
    manager.addListener(SceneManagerEvent.Size, ({ wallConfig, size: { width, depth, height } }) => {
        setFloorSize(width, depth);
        clearWalls();
        buildWalls(width, depth, height, wallConfig);
        clearTrasses();
        generateTrasses();
    });
    //====================================================================== Clear Scene
    manager.addListener(SceneManagerEvent.Clear, () => {
        var _delObj = [];
        scene.traverse((child) => {
            if (child.userData.isRemovable) {
                _delObj.push(child);
            }
        });
        for (var i = 0; i < _delObj.length; i++) {
            scene.remove(_delObj[i]);
        }
        clearTrasses();
    });
    //====================================================================== Object loader
    function addItem(item) {
        let meshUrl = item.type;
        if (item.spitshield) {
            meshUrl += "mitSs";
        }
        if (!item.type.startsWith("Door_")) {
            if (item.textile && item.textile2) {
                meshUrl += "_textile";
            }
            else if (item.textile && !item.textile2) {
                meshUrl += "_textileFront";
            }
            else if (!item.textile && item.textile2) {
                meshUrl += "_textileBack";
            }
        }
        //use variant value for all items except panels
        if (item.variant && !item.type.includes("Pannel_")) {
            //some variants erroneously have an underscore in the inventory.json
            meshUrl += "_" + (item.variant.startsWith("_") ? item.variant.slice(1) : item.variant);
        }
        gltfLoader.load(`glb/${meshUrl}.glb`, (gltf) => {
            var _a, _b, _c, _d, _e, _f;
            let mesh = gltf.scene.children[0];
            mesh.name = item.id;
            mesh.position.set((_a = item.x) !== null && _a !== void 0 ? _a : spawnLocation.x, (_b = item.y) !== null && _b !== void 0 ? _b : spawnLocation.y, (_c = item.z) !== null && _c !== void 0 ? _c : spawnLocation.z);
            mesh.setRotationFromAxisAngle(new Vector3(0, 1, 0), (_d = item.rY) !== null && _d !== void 0 ? _d : 0);
            item.x = mesh.position.x;
            item.y = mesh.position.y;
            item.z = mesh.position.z;
            mesh.userData.isSelectable = (_e = item.isSelectable) !== null && _e !== void 0 ? _e : true;
            mesh.userData.isRemovable = (_f = item.isRemovable) !== null && _f !== void 0 ? _f : true;
            if (item.type === "Pannel_100x250") {
                mesh.userData.isRemovable = false;
            }
            if (item.type.startsWith("Door_")) {
                mesh.userData.isPannel = true;
                mesh.userData.variant = parseInt(item.variant, 10) / 100;
                walls.add(mesh);
            }
            if (item.type.startsWith("Pannel_")) {
                mesh.userData.isPannel = true;
                mesh.userData.height = parseInt(item.variant, 10) / 100;
                mesh.scale.y = parseInt(item.variant, 10) / 100;
                if (item.type.startsWith("Pannel_") || item.type.startsWith("Door_"))
                    walls.add(mesh);
            }
            if (item.type.startsWith("02010001") || item.type.startsWith("07010013")) {
                mesh.userData.isEdgeMount = true;
            }
            if (item.type.startsWith("01100007") || item.type.startsWith("04100085") || item.type.startsWith("TV")) {
                mesh.userData.isSurfaceMount = true;
            }
            if (item.texture) {
                applyTexture(item, mesh);
            }
            if (item.texture2) {
                applyTexture(item, mesh, false);
            }
            scene.add(mesh);
            if (item.type !== "Pannel_100x250") {
                dragables.push(mesh);
            }
            manager.putItem(item);
            updateMaterials();
        });
    }
    manager.items.forEach((item) => addItem(item));
    manager.addListener(SceneManagerEvent.Add, ({ item }) => {
        addItem(item);
    });
    //====================================================================== Texture loader
    async function applyTexture(item, mesh, front = true) {
        _applyTexture(front ? item.texture : item.texture2, mesh, front ? item.tOffset : item.t2Offset, front ? item.tScale : item.t2Scale, front);
    }
    function _applyTextureOffset(mesh, offset = 0, front = true) {
        const apply = (o) => {
            o.children.forEach(c => {
                const mesh = c;
                if (mesh.material) {
                    if (!Array.isArray(mesh.material) && mesh.material.name === (front ? "PannelFront" : "PannelBack")) {
                        if (mesh.userData.hasTexture = true) {
                            mesh.material = mesh.material.clone();
                            const texture = mesh.material;
                            if (texture === null || texture === void 0 ? void 0 : texture.map) {
                                texture.map.center.set(offset, 0);
                                texture.map.offset.set(offset, 0);
                            }
                        }
                    }
                }
                else {
                    apply(c);
                }
            });
        };
        apply(mesh);
    }
    async function _applyTexture(textureUrl, mesh, offset = 0, repeat = 1, front = true) {
        const texture = await manager.getTexture(textureUrl);
        mesh.userData[front ? 'texture' : 'texture2'] = textureUrl;
        console.log('apply texture!', textureUrl);
        new THREE.TextureLoader().load(texture, texture => {
            texture.flipY = false;
            texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
            texture.offset.set(offset, 0);
            texture.repeat.set(repeat, 1);
            const tryApplyingTexture = (o) => {
                o.children.forEach(c => {
                    const mesh = c;
                    if (mesh.material) {
                        //TODO use same texture name in all models that should be set here
                        if (!Array.isArray(mesh.material) && mesh.material.name === (front ? "PannelFront" : "PannelBack")) {
                            //clone is necessary for banner
                            mesh.material = mesh.material.clone();
                            mesh.material.map = texture;
                            mesh.material.color = mesh.userData.backlight ? backlightOnColor : backlightOffColor;
                            mesh.userData.hasTexture = true;
                            mesh.material.needsUpdate = true;
                        }
                    }
                    else {
                        tryApplyingTexture(c);
                    }
                });
            };
            tryApplyingTexture(mesh);
        });
    }
    manager.addListener(SceneManagerEvent.Update, async ({ item, changed }) => {
        if (changed.includes('variant')) {
            if (item.type.startsWith("Pannel") || item.type.startsWith("Halb")) {
                var _obj = scene.getObjectByName(item.id);
                _obj.scale.y = parseInt(item.variant, 10) / 100;
                _obj.userData.height = parseInt(item.variant, 10) / 100;
            }
            else if (item.type.startsWith("Door")) {
                if (item.type.includes("left"))
                    replaceObject(item, "Door_left_" + item.variant.toString(), item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
                if (item.type.includes("right"))
                    replaceObject(item, "Door_right_" + item.variant.toString(), item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
            }
            else if (item.type.startsWith("TV")) {
                replaceObject(item, "TV_" + item.variant.toString(), item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
            }
            else if (item.spitshield !== undefined) {
                if (item.spitshield === true)
                    replaceObject(item, item.type + "mitSs" + item.variant.toString(), item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
                else
                    replaceObject(item, item.type + item.variant.toString(), item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
            }
            else {
                replaceObject(item, item.type + item.variant.toString(), item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
            }
        }
        if (changed.includes('textile') || changed.includes('textile2')) {
            if (item.type.startsWith("Door"))
                return;
            if (item.textile && item.textile2) {
                replaceObject(item, item.type + "_textile", item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
            }
            if (item.textile && !item.textile2) {
                replaceObject(item, item.type + "_textileFront", item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
            }
            if (!item.textile && item.textile2) {
                replaceObject(item, item.type + "_textileBack", item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
            }
            if (!item.textile && !item.textile2) {
                replaceObject(item, item.type, item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
            }
        }
        if (changed.includes('spitshield')) {
            if (item.spitshield === false)
                replaceObject(item, item.type + item.variant.toString(), item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
            if (item.spitshield === true)
                replaceObject(item, item.type + "mitSs" + item.variant.toString(), item.x, item.y, item.z, item.rY, parseInt(item.variant, 10) / 100);
        }
        if (changed.includes('texture')) {
            if (item.texture) {
                applyTexture(item, scene.getObjectByName(item.id));
            }
            else {
                removePanelTexture(scene.getObjectByName(item.id));
            }
        }
        if (changed.includes('texture2')) {
            if (item.texture2) {
                applyTexture(item, scene.getObjectByName(item.id), false);
            }
            else {
                removePanelTexture(scene.getObjectByName(item.id), false);
            }
        }
        if (changed.includes("backlight")) {
            scene.getObjectByName(item.id).traverse((child) => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                    if (child.material.name === "PannelFront" || child.material.name === "PannelBack") {
                        if (item.backlight) {
                            child.material.color = backlightOnColor;
                            child.userData.backlight = true;
                        }
                        else {
                            child.userData.backlight = false;
                        }
                    }
                }
            });
        }
    });
    function replaceObject(sceneItem, _newMesh, _posX, _posY, _poxZ, _rotY, _height) {
        console.log("Replacing object:" + sceneItem.id);
        var objToRemove = scene.getObjectByName(sceneItem.id);
        objectToMove = null;
        gltfLoader.load(`glb/${_newMesh}.glb`, (gltf) => {
            scene.remove(objToRemove);
            let mesh = gltf.scene.children[0];
            mesh.name = sceneItem.id;
            mesh.position.set(_posX, _posY, _poxZ);
            mesh.setRotationFromAxisAngle(new Vector3(0, 1, 0), _rotY !== null && _rotY !== void 0 ? _rotY : 0);
            mesh.userData.height = _height;
            mesh.userData.isSelectable = true;
            mesh.userData.isRemovable = true;
            if (_newMesh.startsWith("Pannel_")) {
                mesh.scale.y = _height;
                mesh.userData.isPannel = true;
            }
            else if (_newMesh.startsWith("Door_")) {
                mesh.userData.isPannel = true;
                walls.add(mesh);
            }
            else if (_newMesh.startsWith("TV")) {
                mesh.userData.isSurfaceMount = true;
            }
            for (var i = 0; i < dragables.length; i++) {
                if (dragables[i].name == sceneItem.id) {
                    dragables.splice(i, 1);
                }
            }
            mesh.traverse((child) => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                    if (child.material.name === "PannelFront" || child.material.name === "PannelBack") {
                        if (sceneItem.backlight) {
                            child.material.color = backlightOnColor;
                            child.userData.backlight = true;
                        }
                        else {
                            child.userData.backlight = false;
                        }
                    }
                }
            });
            objectToMove = mesh;
            scene.add(mesh);
            if (!sceneItem.name.startsWith("Außenwand") && !sceneItem.name.startsWith("Outer "))
                dragables.push(mesh);
            updateMaterials();
            if (sceneItem.texture) {
                applyTexture(sceneItem, mesh);
            }
            if (sceneItem.texture2) {
                applyTexture(sceneItem, mesh, false);
            }
        });
    }
    //====================================================================== Floor Texture
    function setFloorType(type) {
        var _tex = null;
        var _brightness = 0.5;
        if (type == "velour_speed") {
            _tex = new THREE.TextureLoader().load("img/velour_speed.jpg");
            _tex.wrapS = _tex.wrapT = THREE.RepeatWrapping;
            _tex.repeat.set(2, 2);
            _brightness = 0.2;
        }
        if (type == "velour_speed_110") {
            _tex = new THREE.TextureLoader().load("img/velour_speed_110.jpg");
            _tex.wrapS = _tex.wrapT = THREE.RepeatWrapping;
            _tex.repeat.set(2, 2);
            _brightness = 0.2;
        }
        if (type == "velour_speed_330") {
            _tex = new THREE.TextureLoader().load("img/velour_speed_330.jpg");
            _tex.wrapS = _tex.wrapT = THREE.RepeatWrapping;
            _tex.repeat.set(2, 2);
            _brightness = 0.2;
        }
        if (type == "velour_speed_550") {
            _tex = new THREE.TextureLoader().load("img/velour_speed_550.jpg");
            _tex.wrapS = _tex.wrapT = THREE.RepeatWrapping;
            _tex.repeat.set(2, 2);
            _brightness = 0.2;
        }
        if (type == "velour_speed_680") {
            _tex = new THREE.TextureLoader().load("img/velour_speed_680.jpg");
            _tex.wrapS = _tex.wrapT = THREE.RepeatWrapping;
            _tex.repeat.set(2, 2);
            _brightness = 0.2;
        }
        if (type == "velour_speed_880") {
            _tex = new THREE.TextureLoader().load("img/velour_speed_880.jpg");
            _tex.wrapS = _tex.wrapT = THREE.RepeatWrapping;
            _tex.repeat.set(2, 2);
            _brightness = 0.2;
        }
        if (type == "velour_speed_990") {
            _tex = new THREE.TextureLoader().load("img/velour_speed_990.jpg");
            _tex.wrapS = _tex.wrapT = THREE.RepeatWrapping;
            _tex.repeat.set(2, 2);
            _brightness = 0.2;
        }
        if (type == "laminate_white") {
            _tex = new THREE.TextureLoader().load("img/laminate_white.jpg");
            _tex.wrapS = _tex.wrapT = THREE.RepeatWrapping;
            _tex.repeat.set(2, 2);
            _brightness = 0.6;
        }
        if (type == "laminate_wood") {
            _tex = new THREE.TextureLoader().load("img/laminate_wood.jpg");
            _tex.wrapS = _tex.wrapT = THREE.RepeatWrapping;
            _tex.repeat.set(5, 3);
            _brightness = 0.5;
        }
        if (_tex != null) {
            scene.traverse((child) => {
                if (child.userData.isFloor && child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                    child.material.map = _tex;
                    child.material.color = new THREE.Color(_brightness, _brightness, _brightness);
                    child.material.needsUpdate = true;
                }
            });
        }
    }
    setFloorType(manager.floor);
    manager.addListener(SceneManagerEvent.Floor, ({ floor }) => {
        setFloorType(floor);
    });
    //====================================================================== Materials
    function updateMaterials() {
        scene.traverse((child) => {
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                if (child.material.name === "glass" || child.material.name === "glas") {
                    child.material.transparent = true;
                    child.material.depthWrite = true;
                    child.material.depthTest = true;
                    child.material.opacity = 0.4;
                    child.material.color = new THREE.Color(0.6, 0.6, 0.7);
                    child.material.roughness = 0.96;
                    child.material.metalness = 0.6;
                }
                if (child.material.name === "glass_white") {
                    child.material.transparent = true;
                    child.material.depthWrite = true;
                    child.material.depthTest = true;
                    child.material.opacity = 0.4;
                    child.material.color = new THREE.Color(0.5, 0.5, 0.7);
                    child.material.roughness = 0.1;
                    child.material.metalness = 0.4;
                }
                if (child.material.name === "plexiglass") {
                    child.material.transparent = true;
                    child.material.depthWrite = true;
                    child.material.depthTest = true;
                    child.material.opacity = 0.6;
                    child.material.color = new THREE.Color(0.7, 0.75, 0.93);
                    child.material.roughness = 0.95;
                    child.material.metalness = 0.7;
                }
                if (child.material.name === "Floor") {
                    child.material.color = new THREE.Color(1, 1, 1);
                    child.material.roughness = 0.985;
                    child.material.metalness = 0.0;
                }
                if (child.material.name == "Collider" || child.material.name === "collider") {
                    child.material.visible = false;
                }
                if (child.material.name == "Selector" || child.material.name === "selector") {
                    child.material.visible = false;
                }
                if (child.material.name == "shadow") {
                    child.material.roughness = 1;
                    child.material.metalness = 0;
                    child.material.transparent = true;
                    child.material.depthWrite = false;
                    child.material.depthTest = true;
                    child.material.blendEquationAlpha = 1;
                    child.material.opacity = 0.5;
                }
            }
        });
    }
    function saveMaterials() {
        objectToMove.traverse((child) => {
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                matColors.push(child.material.color);
            }
        });
        assignHighlightColor();
    }
    function assignHighlightColor() {
        objectToMove.traverse((child) => {
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                child.material.color = highlightColor;
            }
        });
    }
    function restoreMaterials() {
        var counter = selectedObjects.length;
        matColors.reverse();
        selectedObjects.reverse();
        for (var i = 0; i < counter; i++) {
            selectedObjects.pop().traverse((child) => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                    if (child.material.name == "PannelFront" && child.userData.hasTexture) {
                        if (child.userData.backlight) {
                            child.material.color = backlightOnColor;
                        }
                        else {
                            child.material.color = backlightOffColor;
                        }
                        matColors.pop();
                    }
                    else if (child.material.name == "PannelBack" && child.userData.hasTexture) {
                        if (child.userData.backlight) {
                            child.material.color = backlightOnColor;
                        }
                        else {
                            child.material.color = backlightOffColor;
                        }
                        matColors.pop();
                    }
                    else {
                        if (child.material.name == "PannelFront" || child.material.name == "PannelBack") {
                            child.material.color = child.userData.backlight ? backlightOnColor : new THREE.Color(0.95, 0.95, 0.95);
                            matColors.pop();
                        }
                        else {
                            child.material.color = matColors.pop();
                        }
                    }
                }
            });
        }
    }
    function removePanelTexture(_panel, front = true) {
        if (!_panel) {
            return;
        }
        _panel.traverse((child) => {
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                if (child.material.name === (front ? "PannelFront" : "PannelBack")) {
                    child.material.roughness = 1;
                    child.material.metalness = 0;
                    child.material.color = new THREE.Color(0.95, 0.95, 0.95);
                    child.material.map = null;
                    child.material.needsUpdate = true;
                    child.userData.hasTexture = false;
                }
            }
        });
    }
    //====================================================================== OrbitControls settings
    const controls = new OrbitControls(camera, renderTarget);
    controls.enableDamping = true;
    controls.dampingFactor = 0.1;
    controls.target.set(0, 1, 0);
    controls.maxPolarAngle = Math.PI / 2;
    controls.maxDistance = 12;
    //====================================================================== Loop
    var runTimer = false;
    var timerActive = false;
    const timer = new THREE.Clock();
    function animate() {
        controls.update();
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
        //drag delay
        if (runTimer && !shadowTarget) {
            if (!timerActive) {
                timer.start();
                timerActive = true;
            }
            if (timer.getElapsedTime() > 0.15) {
                if (currentSelection != null && currentSelection.userData.isSurfaceMount) {
                    dragOnSurface(currentSelection);
                }
                else if (currentSelection != null && currentSelection.userData.isEdgeMount) {
                    dragOnEdge(currentSelection);
                }
                else {
                    dragControls.enabled = true;
                }
                timer.stop();
            }
        }
        else {
            dragControls.enabled = false;
            timer.stop();
            timerActive = false;
        }
    }
    animate();
    function handleResize() {
        const width = renderTarget.offsetWidth;
        const height = renderTarget.offsetHeight;
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
        renderer.setSize(width, height);
    }
    window.addEventListener('resize', handleResize);
    setTimeout(handleResize, 100);
}
